/* unplugin-vue-components disabled */import { render } from "./LoadingSection.vue?vue&type=template&id=2e7e23ed"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__